const LK_CheckboxUnchecked =({color,width,height})=>{
    return(
        <svg width={width} height={height} viewBox="0 0 15 15" fill={'none'} xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="14" height="14" rx="2.5" stroke={color}/>
        </svg>
    );
};

export default LK_CheckboxUnchecked;